export enum OAuthRequestUrls {
  login = 'oauth/token',
  registerMobile = 'oauth/mobile',
  confirmMobile = 'oauth/mobile/confirm',
  registerEmail = 'consumer/verify-email',
  refresh = 'oauth/refresh',
}
